import { render, staticRenderFns } from "./Gradient.vue?vue&type=template&id=64fdb5f2&scoped=true&"
import script from "./Gradient.vue?vue&type=script&lang=js&"
export * from "./Gradient.vue?vue&type=script&lang=js&"
import style0 from "./Gradient.vue?vue&type=style&index=0&id=64fdb5f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fdb5f2",
  null
  
)

export default component.exports